import { ref } from 'vue';
import { useRoute } from 'vue-router';

const token = ref('');
const memberCode = ref('');

export const init = (api) => {
  const route = useRoute();
  memberCode.value = route.query.m;
  token.value = route.query.t;

  api.updateToken(token.value);
};

export const getMemberCode = () => {
  return memberCode.value;
};

export const setMemberCode = (newValue) => {
  memberCode.value = newValue;
};
